import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  secondaryColor: {
    color: '#D71867',
  },
  greyBg: {
    backgroundColor: '#f1f1f1',
  },
  primaryBg: {
    backgroundColor: '#7833FF',
    color: theme.palette.common.white,
  },
  notAvailableAlert: {
    marginBottom: theme.spacing(8),
    padding: theme.spacing(2, 4),
    textAlign: 'center',
    borderRadius: 15,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.common.white,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      marginTop: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',

      '& img': {
        marginTop: 0,
      },
    },
  },
  headerTextBox: {
    marginBottom: theme.spacing(6),

    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      marginTop: theme.spacing(-6),
    },
  },
  headerSubtext: {
    '& svg': {
      fontSize: theme.typography.h1.fontSize,
      color: '#7833FF',

      [theme.breakpoints.up('md')]: {
        marginLeft: theme.spacing(4),
      },
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  stepsBox: {
    position: 'relative',
    marginTop: theme.spacing(-10),
    padding: theme.spacing(6),
    backgroundColor: '#7833FF',
    borderRadius: 20,
    color: theme.palette.common.white,
  },
  steps: {
    margin: theme.spacing(6, 0),
    color: theme.palette.common.white,
  },
  stepsNumberBox: {
    color: '#7833FF',
    backgroundColor: theme.palette.common.white,
  },
  button: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    color: theme.palette.common.white,
    background: 'none',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: '#7833FF',
    },
  },
  videoBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',
    },
  },
  video: {
    marginTop: theme.spacing(4),

    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  sharedIcons: {
    color: '#fff',
    marginTop: '20px',
    marginLeft: '10px',
    marginRight: '10px',
  },
}));
